import React from 'react';
import { useSessionContext } from './SessionContext';
import { ATTRIBUTE_OPTIONS } from './utils';

export default function Legend() {
  const { selectedAttribute } = useSessionContext();
  const attribute = ATTRIBUTE_OPTIONS[selectedAttribute];
  const colorStops = Array.from({ length: 10 }, (_, i) => i / 9)
    .map((value) => `${attribute.colorMapInterpolator(value)} ${(value * 100).toFixed(0)}%`)
    .join(', ');

  return (
    <div style={{ fontSize: '14px', fontWeight: 'bold' }}>
      <div
        className="split-spans"
        style={{ margin: '0 4px 2px' }}
      >
        <span>{attribute.rangeValues[0]}</span>
        <span>{attribute.rangeTitle}</span>
        <span>{attribute.rangeValues[1]}</span>
      </div>
      <div
        className="legend-gradient"
        style={{ background: `linear-gradient(to right, ${colorStops})` }}
      />
      <div className="split-spans" style={{ margin: '2px 4px' }}>
        <span>{attribute.rangeLabels[0]}</span>
        <span>{attribute.rangeLabels[1]}</span>
      </div>
    </div>
  );
}
